import { Component, Input } from '@angular/core';
import { ItemAttachmentsStoreService } from './item-attachments-store.service';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { map, takeUntil } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { MomentModule } from 'ngx-moment';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { UserIdToNamePipe } from '../pipes/user-id-to-name.pipe';
import { MatButton, MatIconAnchor, MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-item-attachments',
    templateUrl: './item-attachments.component.html',
    providers: [ItemAttachmentsStoreService],
    standalone: true,
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatButton, NgFor, MatIconAnchor, MatIconButton, AsyncPipe, UserIdToNamePipe, FileSizePipe, MomentModule]
})
export class ItemAttachmentsComponent {
  @Input() set itemId(value: number) {
    this.itemAttachmentsStoreService.setItemId(value);
  }

  uploadForm = new FormGroup({
    file: new FormControl<File>(null, {
      validators: [Validators.required],
      nonNullable: true
    }),
    description: new FormControl<string>('', {
      validators: [Validators.required],
      nonNullable: true
    })
  });

  constructor(
    private itemAttachmentsStoreService: ItemAttachmentsStoreService,
    private dialog: MatDialog
  ) {}

  readonly loading$ = this.itemAttachmentsStoreService.loading$;
  readonly attachments$ = this.itemAttachmentsStoreService.attachments$;
  readonly showList$ = this.attachments$.pipe(
    map((attachments) => attachments.length > 0)
  );
  dateFormat = ConfigService.dates.longDateTimeFormat;

  addAttachment() {
    if (this.uploadForm.valid) {
      this.itemAttachmentsStoreService.addAttachment({
        ...this.uploadForm.value,
        onSuccess: () => this.uploadForm.reset()
      } as any);
    }
  }

  deleteAttachment(id: number) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Delete attachment',
          message: 'Are you sure you want to delete this attachment?'
        }
      })
      .afterClosed()
      .pipe(takeUntil(this.itemAttachmentsStoreService.destroy$))
      .subscribe((result) => {
        if (result) {
          this.itemAttachmentsStoreService.deleteAttachment(id);
        }
      });
  }

  handleFileInput(eventTarget: EventTarget) {
    const files = (eventTarget as HTMLInputElement).files;
    if (files.length) {
      this.uploadForm.patchValue({ file: files.item(0) });
    } else {
      this.uploadForm.patchValue({ file: null });
    }
  }
}
